/**
 * What the search panel reports about its search once the gallery has loaded the filters.
 *
 * The count only exists after the gallery has run the filters, so it is sent once per search, and
 * only after the panel has seen that load start: otherwise the plan arrives before the reload and
 * the previous search's total gets recorded. When the load fails, the gallery keeps showing that
 * previous total too, so a failure is reported as a failure and the count stays unknown.
 *
 * @returns {{action: 'none'}|{action: 'wait'}|{action: 'failure', code: string}|{action: 'count', count: number}}
 */
export const settleResultsReport = ({ logId, applicable, reported, awaiting, loading, failure, count }) => {
  if (!logId || applicable === false || reported === logId) return { action: 'none' };
  if (loading) return { action: 'wait' };
  if (awaiting !== logId) return { action: 'none' };
  if (failure) return { action: 'failure', code: failure };
  return { action: 'count', count: Number(count) || 0 };
};
